import { createSelector } from 'reselect';
import { getIn } from 'icepick';
import { forEach, values, filter } from 'lodash';

export const getSelectedMerchantAccountId = (event) => {
  return event.eventFeatureSetup.fees ? event.eventFeatureSetup.fees.merchantAccountId : null;
};

export const isFeesEnabled = (event) => {
  return event.eventFeatureSetup.fees ? event.eventFeatureSetup.fees.fees : false;
};

export const isDiscountCodesEnabled = (event) => {
  return event.eventFeatureSetup.fees ? event.eventFeatureSetup.fees.discounts : false;
};

export const isAdmissionItemsEnabled = (event) => {
  return event.eventFeatureSetup.agendaItems ?
    event.eventFeatureSetup.agendaItems.admissionItems : false;
};

export const getOptionalSessions = (event) => {
  return getIn(event, ['products', 'sessionContainer', 'optionalSessions']) || {};
};

export const getIncludedSessions = (event) => {
  return getIn(event, ['products', 'sessionContainer', 'includedSessions']) || {};
};

export const getSessionCategoryListOrders = (event) => {
  return getIn(event, ['products', 'sessionContainer', 'sessionCategoryListOrders']) || {};
};

export const sessionStatus = {
  active: 2,
  closed: 3,
  cancelled: 7
};

export const getAllSessions = createSelector(
  getOptionalSessions,
  getIncludedSessions,
  (optionalSessions, includeSessions) => {
    return { ...optionalSessions, ...includeSessions };
  });

export const getSessionGroups = (event) => {
  return getIn(event, ['products', 'sessionContainer', 'sessionGroups']) || {};
};

/* Retrieve all optional and included sessions and sessions within session groups */
export const getSessions = createSelector(
  getAllSessions,
  getSessionGroups,
  (sessionsContainer, groupSessionsContainer) => {
    const sessions = values(sessionsContainer);
    let groupSessions = [];
    forEach(groupSessionsContainer, group => {
      groupSessions = groupSessions.concat(values(group.sessions));
    });
    return [...sessions, ...groupSessions];
  }
);

const defaultSpeakerInfo = Object.freeze({});
const getSpeakerInfo = (event) => {
  return getIn(event, ['speakerInfoSnapshot']) || defaultSpeakerInfo;
};

export const getSpeakerCategoryOrder = createSelector(
  getSpeakerInfo,
  (speakerInfo) => {
    return speakerInfo.categoryOrder || {};
  }
);

const defaultSpeakers = Object.freeze({});
export const getSpeakers = createSelector(
  getSpeakerInfo,
  (speakerInfo) => {
    return speakerInfo.speakers || defaultSpeakers;
  }
);

export const getWebsiteSpeakers = createSelector(
  getSpeakers,
  (speakers) => {
    return filter(speakers, speaker => !!speaker.displayOnWebsite);
  }
);

// This is to check if waitlist is enabled at the event level and will be used
// mainly by the site designer and the basis for guest side as well.
// We added reg path level waitlist flag check at the guest side.
export const isWaitlistEnabled =
  (event) => getIn(event, ['eventFeatureSetup', 'registrationProcess', 'eventWaitlist']) || false;

// This is to check if registration approval is enabled at the event level and will be used
// mainly by the site designer and the basis for guest side as well.
// We added reg path level registration aproval flag check at the guest side.
export const isRegistrationApprovalEnabled =
  (event) => getIn(event, ['eventFeatureSetup', 'registrationProcess', 'registrationApproval']) || false;

